// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var canteenProductRouter = {
  path: '/activity-product',
  component: Layout,
  redirect: '/activity-product/list',
  name: 'ActivityProduct',
  meta: {
    title: '活动',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/activity-product/index');
    },
    name: 'ActivityProductList',
    meta: {
      title: '活动',
      icon: ''
    }
  }, {
    path: 'backrule',
    component: function component() {
      return import('@/views/activity-product/back/index');
    },
    name: 'Backrule',
    meta: {
      title: '退货规则',
      icon: ''
    }
  }, {
    path: 'limitrule',
    component: function component() {
      return import('@/views/activity-product/limit/index');
    },
    name: 'Backrule',
    meta: {
      title: '限购规则',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return import('@/views/product/attr/index');
    },
    name: 'ProductAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType?',
    component: function component() {
      return import('@/views/activity-product/creatProduct/index');
    },
    name: 'creatActivityProduct',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/activity-product/list"
    },
    hidden: true
  }, {
    path: 'list/retention',
    component: function component() {
      return import('@/views/order/retention');
    },
    name: 'ActivityRetentionOrder',
    meta: {
      title: '留资订单',
      noCache: true,
      activeMenu: "/activity-product/list"
    },
    hidden: true
  }]
};
export default canteenProductRouter;